import { Journey } from 'src/common/interfaces/journey.interface';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';

export const getJourneyAliasById = (journey: Journey, alias_id: number) => {
  return journey.aliases.find((alias: JourneyAlias) => alias.id === alias_id);
};
